import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { ConfigProvider } from 'antd';
import { apolloClient } from './lib/apollo';
import { AuthProvider } from './hooks/useAuth';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { VerifyCode } from './pages/VerifyCode';
import { Dashboard } from './pages/Dashboard';
import { Users } from './pages/Users';
import { Organizations } from './pages/Organizations';
import { Parkings } from './pages/Parkings';
import { Pricing } from './pages/Pricing';
import { Operations } from './pages/Operations';
import { Analytics } from './pages/Analytics';

const App: React.FC = () => {
  return (
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#003874',
            colorLink: '#003874',
            colorInfo: '#94AFCC',
            borderRadius: 4,
          },
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify" element={<VerifyCode />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              <Route path="organizations" element={<Organizations />} />
              <Route path="parkings" element={<Parkings />} />
              <Route path="pricing" element={<Pricing />} />
              <Route path="operations" element={<Operations />} />
              <Route path="analytics" element={<Analytics />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
      </AuthProvider>
    </ApolloProvider>
  );
};

export default App;
